import { Menu } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { mainSelectedTab } from "../../atoms";
import { useRecoilState, useRecoilValue } from "recoil";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { ICarriers } from "../types";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { OFFICE_PERMISSIONS } from "modules/CarrierAgreementMgmt/OfficeSettings/permission";
interface ViewSettingsProps {
  carrierDetails: ICarriers;
}
const ViewSettings = ({ carrierDetails }: ViewSettingsProps): JSX.Element => {
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const viewAgreementPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_agreement_view;
  const viewOfficePermission =
    OFFICE_PERMISSIONS.permission_carrieragreemnentmgmt_office_view;
  const viewProdCodePermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_producercode_view;
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const handleViewSettingsClick = (
    pathName,
    carrierDetailsId,
    moduleName,
    groupTabName
  ) => {
    const url = groupTabName + pathName;
    history.push({
      pathname: url,
      state: {
        recordId: carrierDetailsId,
        moduleName: moduleName,
        action: "viewSettings",
      },
    });
    let userTabs = [
      {
        to: "",
      },
    ];
    [...CarrierAgreementMgmtTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
    globalThis.location.reload();
  };

  const handleViewOfficeClick = (pathName, carrierDetailsId, moduleName) => {
    const url = "/officesettings/" + pathName;
    const index = OfficeTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
    history.push({
      pathname: "/officesettings/" + pathName,
      state: {
        recordId: carrierDetailsId,
        moduleName: moduleName,
        action: "viewSettings",
      },
    });
    globalThis.location.reload();
  };
  return (
    <>
      <Menu>
        <Menu.Button className="opacity-100 flex justify-between items-center text-md text-left text-tertiary">
          View Settings
          <ChevronRightIcon className="w-4 h-4 mt-.5 pl-1" />
        </Menu.Button>
        <Menu.Items className="border-l-4 box-shadow border border-primary grid grid-rows-3 absolute -mt-8 ml-24 -mr-48 z-50 text-xs gap-2 px-2 py-3 text-tertiary text-left font-medium bg-white shadow-md divide-y divide-gray-200 rounded-md">
          {userPermissions.includes(viewAgreementPermission) && (
            <Menu.Item>
              {({ active }) => (
                <button
                  className={`${
                    active && "text-center text-xs font-medium  rounded-sm "
                  }`}
                  onClick={() =>
                    handleViewSettingsClick(
                      "agreements",
                      carrierDetails.masterCarrierId,
                      "Agreement",
                      "/carrieragreementmgmt/"
                    )
                  }
                >
                  AGREEMENT MODULE
                </button>
              )}
            </Menu.Item>
          )}
          {userPermissions.includes(viewOfficePermission) && (
            <Menu.Item>
              {({ active }) => (
                <button
                  className={`${
                    active && "text-center text-xs font-medium rounded-sm "
                  }`}
                  onClick={() =>
                    handleViewOfficeClick(
                      "officesetting",
                      carrierDetails.masterCarrierId,
                      "Office"
                    )
                  }
                >
                  OFFICE MODULE
                </button>
              )}
            </Menu.Item>
          )}
          {userPermissions.includes(viewProdCodePermission) && (
            <Menu.Item>
              {({ active }) => (
                <button
                  className={`${
                    active && "text-center text-xs font-medium  rounded-sm "
                  }`}
                  onClick={() => {
                    handleViewSettingsClick(
                      "producercodeconfig/table",
                      carrierDetails.masterCarrierId,
                      "Producer Code",
                      "/carrieragreementmgmt/"
                    );
                  }}
                >
                  PRODUCER CODE MODULE
                </button>
              )}
            </Menu.Item>
          )}
        </Menu.Items>
      </Menu>
    </>
  );
};

export default ViewSettings;
